module.exports = __webpack_public_path__ + "static/media/scanid.13d3d13e.svg";